import { render } from "./deptSelect.vue?vue&type=template&id=f174af4a&scoped=true"
import script from "./deptSelect.vue?vue&type=script&lang=js"
export * from "./deptSelect.vue?vue&type=script&lang=js"

import "./deptSelect.vue?vue&type=style&index=0&id=f174af4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f174af4a"]])

export default __exports__